PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
SelectMemberView = require 'views/member/select-member-view'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
l = require 'lib/localize'
ninvoke = require 'lib/util/ninvoke'

# Mixin for views that search for members on the site to add to their models'
# memberships.
module.exports = class MemberSearchView extends View
  previousRender: null

  renderSearchResults: (search, members) ->
    @$('.js-org-members').hide()
    @$el.find('.js-error').hide()
    $searchResultsSection = @$el.find('.js-search-results')
    $searchResultsList = $searchResultsSection.find('.js-list').empty()
    $uninvitedResultsSection = @$el.find('.js-uninvited-search-results').hide().empty()

    if search == ''
      @clearSearchResults()
      @loadingEl.hide()
      return

    noResults = _.isEmpty members
    expectingResults = search.trim().length >= 3
    isEmailSearch = members.length == 1 && Util.checkEmail(search)

    @$('.js-no-results').toggleClass('hide', !noResults)
    $searchResultsSection.toggle(!noResults)

    if !expectingResults && noResults
      @renderOrgMembers?()

    @helperEl.hide()

    if !noResults && !members[0].id?
      #first item isn't really a member (just email)
      @renderEmailInviteToSearchResults(members[0])

      $searchResultsSection.hide()
      @loadingEl.hide()
      return

    @previousRender?.cancel()
    @previousRender = Promise.resolve(members)
    .map (memberData) =>
      joined = memberData.joined
      sharesBoardsOrOrgs = (memberData.similarity > 0)
      delete memberData.joined
      delete memberData.similarity

      data = { id: memberData.id }

      if joined
        if memberData.memberType == 'ghost'
          data.extraText = l('invited')
        else
          data.extraText = l('joined')

        data.className = 'disabled'
      else if (org = @model.getOrganization?())? && (member = @modelCache.get('Member', memberData.id))?
        if org?.hasActiveMembership(member)
          data.extraText = l('member-of-org', { orgName: org.get('displayName') }, { raw: true })

      data.isKnownMember = sharesBoardsOrOrgs || isEmailSearch

      ninvoke @modelCache, 'enqueueDelta', 'Member', memberData
      .return data
    .cancellable()
    .tap =>
      # Because the data option may change, we don't want to reuse these
      # subviews
      @deleteSubviewsOfType(SelectMemberView)
    .each (data) =>
      @appendMemberToSearchResults(data)
      return
    .tap =>
      @loadingEl.hide()
      $elem = @$('.js-search-results .js-list li.js-autoselect:first')
      Util.selectMenuItem(@$('.js-search-results .js-list'), 'li', $elem)
    .catch Promise.CancellationError, (->)

  appendMemberToSearchResults: (data) ->
    member = @modelCache.get('Member', data.id)
    org = @model.getOrganization?()

    if org?.isPremOrgAdmin(member)
      className = _.compact([data.className, 'no-option']).join(' ')
    else
      className = data.className

    memberView = @subview(SelectMemberView, member, _.extend({
      showUnconfirmed: true
      showInactive: true
    }, data))

    @appendSubview(
      memberView
      @$('.js-search-results .js-list')
    )

    memberView.$('li').addClass(className)



// WEBPACK FOOTER //
// ./app/scripts/views/search/member-search-view.coffee